import React, { useState } from 'react';
import { siteConfig } from '../data/config';

const Jokes = () => {
    const [videoCount, setVideoCount] = useState(6);

    return (
        <section className="jokes-section">
            <div className="container">
                <h2>Mes Dernières Vidéos</h2>
                <div className="jokes-grid">
                    {[...Array(videoCount)].map((_, index) => (
                        <div key={index} className="video-container">
                            <iframe
                                src={`https://www.youtube.com/embed?listType=playlist&list=${siteConfig.youtubePlaylist}&index=${index + 1}`}
                                title={`YouTube video ${index + 1}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    ))}
                </div>
                
                <div className="show-more-container">
                    <button 
                        className="show-more-button"
                        onClick={() => setVideoCount(prev => prev + 3)}
                    >
                        Charger plus
                    </button>
                    <a 
                        href={siteConfig.socialLinks.youtube}
                        className="youtube-link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Voir toutes les vidéos sur YouTube
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Jokes;